// extracted by mini-css-extract-plugin
module.exports = {"dragDropFile":"styles-module_dragDropFile__BISlZ-5XXNezXFJ7aa243"};